const setBreadcrumbsMultipleLevelsArrayAction = ({ commit }, payload) => {
  commit('setBreadcrumbsMultipleLevelsArray', payload)
}

export default {
  setBreadcrumbsMultipleLevelsArrayAction,
}
